var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "1000" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("utils-popup-input-text", { ref: "utils-popup-input-text" }),
      _c(
        "v-card",
        { staticClass: "pt-3 pb-3" },
        [
          _c(
            "v-card",
            {
              staticClass: "d-flex align-center justify-center ml-5 mr-5",
              attrs: { elevation: "0", outlined: "", height: "50" },
            },
            [
              _c(
                "v-card",
                {
                  staticClass:
                    "pl-4 d-flex align-center justify-center blue--text",
                  attrs: { elevation: "0" },
                },
                [_vm._v(" " + _vm._s(_vm.model ? _vm.model.key : "") + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { icon: "", color: "blue", outlined: "", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.onEditKey()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("mdi-pencil"),
                  ]),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-5 white--text",
                  attrs: { color: "green", elevation: "0", small: "" },
                  on: { click: _vm.onAddPage },
                },
                [
                  _vm._v(" add page "),
                  _c("v-icon", { staticClass: "ml-2" }, [_vm._v("mdi-plus")]),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card",
            {
              staticClass: "d-flex align-center justify-center ml-5 mr-5 mt-3",
              attrs: { elevation: "0", outlined: "" },
            },
            [
              this.model
                ? _c(
                    "v-carousel",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: this.model,
                          expression: "this.model",
                        },
                      ],
                      attrs: {
                        "show-arrows": false,
                        "hide-delimiter-background": "",
                        color: "red",
                        light: "",
                        height: "735",
                      },
                    },
                    _vm._l(this.model.pages, function (page, i) {
                      return _c(
                        "v-carousel-item",
                        { key: i },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "ma-3 pa-3 d-flex align-center justify-center",
                              attrs: {
                                elevation: "0",
                                outlined: "",
                                height: "50",
                              },
                            },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-3 white--text",
                                  attrs: {
                                    disabled: _vm.model.pages.length <= 1,
                                    color: "red",
                                    elevation: "0",
                                    small: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDeletePage(i)
                                    },
                                  },
                                },
                                [
                                  _vm._v(" delete page "),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-2",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("mdi-delete")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "ma-3 d-flex align-center justify-center",
                              attrs: {
                                elevation: "0",
                                outlined: "",
                                height: "70",
                              },
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "pl-2 pr-2 pt-5",
                                attrs: { placeholder: _vm.getTitle(i) },
                                model: {
                                  value: _vm.model.custom_title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "custom_title", $$v)
                                  },
                                  expression: "model.custom_title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "ma-3 pt-3 pb-3 d-flex align-center justify-center",
                              attrs: { elevation: "0", outlined: "" },
                            },
                            _vm._l(page.images, function (image, j) {
                              return _c(
                                "v-card",
                                {
                                  key: j,
                                  staticClass:
                                    "d-flex align-center justify-center mr-3 ml-3",
                                  attrs: { width: "100%", elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { width: "100%" } },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "d-flex align-center justify-center pl-2 pr-2",
                                              attrs: {
                                                elevation: "0",
                                                width: "100%",
                                                height: "40",
                                              },
                                            },
                                            [
                                              _c("v-text-field", {
                                                staticClass: "ml-1 mr-1",
                                                attrs: {
                                                  placeholder: "image id",
                                                  required: "",
                                                },
                                                model: {
                                                  value: image.id,
                                                  callback: function ($$v) {
                                                    _vm.$set(image, "id", $$v)
                                                  },
                                                  expression: "image.id",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { attrs: { width: "100%" } },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "d-flex align-center justify-center mt-2",
                                              attrs: {
                                                elevation: "0",
                                                width: "100%",
                                                height: "200",
                                                outlined: "",
                                              },
                                            },
                                            [
                                              image.id && image.id.length == 0
                                                ? _c("v-progress-circular", {
                                                    staticClass: "ma-2",
                                                    attrs: {
                                                      indeterminate: "",
                                                      color: "blue",
                                                    },
                                                  })
                                                : _c("v-img", {
                                                    staticClass:
                                                      "d-flex align-center justify-center",
                                                    attrs: {
                                                      "max-width": "200",
                                                      src: _vm.getUrl(
                                                        _vm.getFullPath(
                                                          image.id
                                                        )
                                                      ),
                                                    },
                                                  }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "d-flex align-center justify-center",
                                              attrs: {
                                                elevation: "0",
                                                width: "100%",
                                                height: "50",
                                              },
                                            },
                                            [
                                              _c("v-text-field", {
                                                staticClass: "ml-1 mr-3",
                                                attrs: {
                                                  placeholder: _vm.getMessage(
                                                    i,
                                                    j
                                                  ),
                                                  required: "",
                                                },
                                                model: {
                                                  value: image.custom_message,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      image,
                                                      "custom_message",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "image.custom_message",
                                                },
                                              }),
                                              _c("v-checkbox", {
                                                staticClass: "ml-0 mr-0",
                                                model: {
                                                  value: image.highlighted,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      image,
                                                      "highlighted",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "image.highlighted",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "d-flex align-center justify-center ml-3 mr-3 mt-0",
                              attrs: { elevation: "0" },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  items: _vm.addons,
                                  "item-text": "name",
                                  "hide-details": "",
                                  "return-object": "",
                                },
                                model: {
                                  value: _vm.model.addon.type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model.addon, "type", $$v)
                                  },
                                  expression: "model.addon.type",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "d-flex align-center justify-center ml-3 mr-3 mt-2",
                              attrs: {
                                elevation: "0",
                                outlined: "",
                                height: "130",
                              },
                            },
                            [
                              _vm.isAddonCellection(_vm.model.addon.type)
                                ? _c(
                                    "v-card",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-center ml-3 mr-3 mt-2",
                                      attrs: { elevation: "0", height: "50" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { width: "100%" } },
                                        _vm._l(6, function (row) {
                                          return _c(
                                            "v-card-actions",
                                            {
                                              key: row,
                                              staticClass: "ma-0 pa-0",
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c(
                                                    "v-card",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center justify-center ma-0 pa-0",
                                                      attrs: {
                                                        elevation: "0",
                                                        outlined: "",
                                                        height: "50",
                                                        width: "50",
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(row - 1))]
                                                  ),
                                                ],
                                                1
                                              ),
                                              row != 6
                                                ? _c(
                                                    "v-col",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { dense: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-arrow-right-thick"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm.isAddonMessage(_vm.model.addon.type)
                                ? _c(
                                    "v-card",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-center ml-3 mr-3 mt-2",
                                      attrs: { elevation: "0", height: "50" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.getAddonMessage(i)) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "v-card",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-center ml-3 mr-3 mt-2",
                                      attrs: { elevation: "0", height: "50" },
                                    },
                                    [_vm._v(" No addon ")]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }